import {
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Tab,
} from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { AppState } from "../../redux/reducer/rootReducer";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { ShoppingPortalPage } from "../../compenents/Profile/ShoppingPortalPage";
import { WebstoreSettings } from "../../compenents/Profile/WebstoreSettings";
import { ManufacturerSettings } from "../../compenents/Profile/ManufacturerSettings";
import PortalSettingRules from "../../compenents/Profile/PortalSettingRules";
import { IsShopifySetup } from "../../services/utilities/utility";
import {
  SubscriptionFeatureName,
  useHasSubscriptionFeature,
} from "../../services/featurePermissions/subscriptionFeatures";
import { features } from "process";

export const SetupProfilePage: React.FunctionComponent = () => {
  const setupId = useSelector((state: AppState) => state.authReducer.setupId);
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const hasMultiWebsite = useHasSubscriptionFeature(
    SubscriptionFeatureName.MultiWebsite,
  );
  const isSingleSiteShopify =
    !hasMultiWebsite && IsShopifySetup(dmsSetup?.setupType);
  const [value, setValue] = React.useState("webstoreSettings");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const theme = useTheme();

  React.useEffect(() => {
    if (!setupId || setupId === "") {
      setTimeout(() => {
        window.location.href = "/";
      }, 1500);
    }
  }, [setupId]);

  return (
    <>
      <Container maxWidth={false}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
          Setup Profile
        </Typography>
        <Card sx={{ minHeight: "50vh" }}>
          <CardContent>
            <Grid container>
              <TabContext value={value.toString()}>
                <Grid
                  item
                  xs={2}
                  sx={{
                    bgcolor: theme.palette.action.hover,
                    minHeight: "50vh",
                  }}
                >
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                    orientation="vertical"
                    sx={{ mt: 1 }}
                  >
                    <Tab
                      sx={{
                        backgroundColor:
                          value === "webstoreSettings" ? "white" : "inherit",
                      }}
                      label="Webstore Settings"
                      value="webstoreSettings"
                    />
                    <Tab
                      sx={{
                        backgroundColor:
                          value === "manufacturers" ? "white" : "inherit",
                      }}
                      label="Manufacturers"
                      value="manufacturers"
                    />
                    {isSingleSiteShopify && (
                      <Tab
                        sx={{
                          backgroundColor:
                            value === "shoppingPortal" ? "white" : "inherit",
                        }}
                        label="Shopping Portal"
                        value="shoppingPortal"
                      />
                    )}

                    {isSingleSiteShopify && (
                      <Tab
                        sx={{
                          backgroundColor:
                            value === "portalSettingRules"
                              ? "white"
                              : "inherit",
                        }}
                        label="Portal Setting Rules"
                        value="portalSettingRules"
                      />
                    )}
                  </TabList>
                </Grid>
                <Grid item xs={10}>
                  <TabPanel value="webstoreSettings">
                    <WebstoreSettings />
                  </TabPanel>
                  <TabPanel
                    value="manufacturers"
                    sx={{ padding: 0, paddingLeft: 3 }}
                  >
                    <ManufacturerSettings />
                  </TabPanel>
                  {isSingleSiteShopify && (
                    <TabPanel value="shoppingPortal">
                      <ShoppingPortalPage />
                    </TabPanel>
                  )}

                  {isSingleSiteShopify && (
                    <TabPanel value="portalSettingRules">
                      <PortalSettingRules />
                    </TabPanel>
                  )}
                </Grid>
              </TabContext>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </>
  );
};
